import { lazyWithPreload } from 'helpers/lazyWithPreload'

export const HolisticPlan = lazyWithPreload(() => import('./HolisticPlan'))
